
import React from 'react';
import { Star } from 'lucide-react';

const SocialProof = () => {
  return (
    <div className="mt-20 text-center animate-slide-up [animation-delay:400ms] opacity-0">
      <p className="text-lg font-medium">Trusted by 5,000+ artists worldwide</p>
      <div className="flex flex-wrap justify-center gap-4 mt-4">
        <div className="flex items-center space-x-1">
          <Star className="text-yellow-500 w-4 h-4 fill-yellow-500" />
          <Star className="text-yellow-500 w-4 h-4 fill-yellow-500" />
          <Star className="text-yellow-500 w-4 h-4 fill-yellow-500" />
          <Star className="text-yellow-500 w-4 h-4 fill-yellow-500" />
          <Star className="text-yellow-500 w-4 h-4 fill-yellow-500" />
        </div>
        <span className="text-muted-foreground">4.9/5 average rating</span>
      </div>
    </div>
  );
};

export default SocialProof;
